<template>
  <section class="targeting-section">
    <div>
      <h6>{{ headline }}</h6>
      <img v-if="src && alt" :src="src" :alt="alt" class="img-mobile" />
      <p>{{ paragraph }}</p>
    </div>
    <img v-if="src && alt" :src="src" :alt="alt" class="img-laptop" />
  </section>
</template>

<script>
export default {
  props: {
    headline: String,
    paragraph: String,
    src: String,
    alt: String,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

h6 {
  margin-bottom: 12px;
}

.targeting-section {
  margin-bottom: 60px;
  width: 100%;
}

p {
  line-height: 30px;
}

.img-mobile {
  display: none;
}

@media (max-width: $page-table-breakpoint) {
  .img-mobile {
    display: block;
    max-width: 100%;
    margin: 0;
    padding-bottom: 15px;
  }

  .img-laptop {
    display: none;
  }
}
</style>
